import React from 'react';
import { locations, instagramHandle, bookingLink } from '../data/mockData';
import { Instagram, MapPin, MessageCircle } from 'lucide-react';

const Footer = () => {
  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/morea_dressrental.ec', '_blank');
  };

  const handleBookingClick = () => {
    window.open(bookingLink, '_blank');
  };

  return (
    <footer className="bg-neutral-900 text-white py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-serif tracking-wider mb-4">MOREA</h3>
            <p className="text-neutral-400 font-light leading-relaxed">
              Alquiler de vestidos para eventos especiales en Quito y Guayaquil
            </p>
            <button
              onClick={handleInstagramClick}
              className="flex items-center gap-2 mt-4 text-neutral-300 hover:text-white transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <span className="font-light">{instagramHandle}</span>
            </button>
          </div>

          {/* Locations */}
          <div>
            <h4 className="text-lg font-serif mb-4">Nuestras sedes</h4>
            <div className="space-y-6">
              {locations.map((location) => (
                <div key={location.id}>
                  <h5 className="text-white font-light mb-2">{location.city}</h5>
                  <div className="flex items-start mb-2">
                    <MapPin className="w-4 h-4 text-neutral-400 mt-1 mr-2 flex-shrink-0" />
                    <p className="text-sm text-neutral-400 font-light">{location.address}</p>
                  </div>
                  <div className="flex items-center">
                    <MessageCircle className="w-4 h-4 text-neutral-400 mr-2" />
                    <p className="text-sm text-neutral-400 font-light">{location.whatsappDisplay}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-serif mb-4">Enlaces rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => document.getElementById('featured-dresses')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-neutral-400 hover:text-white transition-colors font-light"
                >
                  Vestidos
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-neutral-400 hover:text-white transition-colors font-light"
                >
                  ¿Cómo alquilar?
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('locations')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-neutral-400 hover:text-white transition-colors font-light"
                >
                  Sedes
                </button>
              </li>
              <li>
                <button
                  onClick={handleBookingClick}
                  className="text-neutral-400 hover:text-white transition-colors font-light"
                >
                  Agenda tu cita
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-neutral-400 hover:text-white transition-colors font-light"
                >
                  Preguntas frecuentes
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-800 pt-8 text-center">
          <p className="text-neutral-400 font-light text-sm">
            © {new Date().getFullYear()} Morea Dress Rental Ecuador. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
